enum ComboUpsellType {
  MenuItem = 'menu-item',
  ComboBuilderModGroup = 'combo-builder-mod-group',
}

export { ComboUpsellType };
